import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../lib/assets";

const LOCATIONS = [
  { no: "I", name: "Yale Street", line1: "4601 Yale St", line2: "Houston, Texas 77018", img: IMAGES.yaleOffice },
  { no: "II", name: "The Heights", line1: "1624 Heights Blvd", line2: "Houston, Texas 77008", img: IMAGES.heightsOffice },
];

export const Locations = () => {
  return (
    <section id="locations" className="relative bg-ink py-28 md:py-40 border-t border-charcoal/40" data-testid="locations">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="mb-16 md:mb-20">
          <Reveal><div className="overline mb-6">Locations</div></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light text-ivory text-5xl md:text-7xl leading-[0.98] tracking-tight max-w-2xl">
              Rooted across Houston.
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {LOCATIONS.map((loc, i) => (
            <Reveal key={loc.name} delay={i * 0.1}>
              <motion.a
                href={`https://maps.google.com/?q=${encodeURIComponent(loc.line1 + " " + loc.line2)}`}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ y: -8 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                className="group relative block overflow-hidden bg-card border border-charcoal/60"
                data-testid={`location-card-${i}`}
              >
                <div className="relative overflow-hidden aspect-[16/11]">
                  <img
                    src={loc.img}
                    alt={`Houston Title Co. — ${loc.name} office`}
                    className="h-full w-full object-cover transition-transform [transition-duration:1400ms] group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
                  <span className="absolute top-6 left-6 font-serif text-ivory text-2xl drop-shadow-lg">{loc.no}</span>
                </div>

                <div className="p-8 md:p-10">
                  <div className="flex items-start justify-between gap-6">
                    <h3 className="font-serif text-3xl md:text-4xl text-ivory font-light">{loc.name}</h3>
                    <MapPin size={20} strokeWidth={1.2} className="mt-2 text-taupe transition-colors duration-300 group-hover:text-gold" />
                  </div>
                  <p className="text-taupe font-light leading-relaxed mt-5">
                    {loc.line1}
                    <br />
                    {loc.line2}
                  </p>
                  <span className="mt-8 inline-flex items-center gap-3 text-[0.72rem] uppercase tracking-[0.2em] text-gold">
                    View on Map
                    <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
                  </span>
                </div>
                <span className="absolute bottom-0 left-0 h-px w-0 bg-gold transition-all duration-700 group-hover:w-full" />
              </motion.a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
